import { action, computed, observable } from 'mobx';

import { ViewController } from '@estee/elc-service';

import { SignInType } from '~constants/SignInTypeEnum';
import { ConfigRepository } from '~repositories/ConfigRepository';
import { UserRepository } from '~repositories/UserRepository';
import { SocialSignInClickedUseCase } from '~use-cases/social/SocialSignInClickedUseCase';
import { getSocialProviderFromStorage } from '~utils/SocialUtils';

interface ISocialButtonWrapperViewController {
    configRepository: ConfigRepository;
    userRepository: UserRepository;
}

export class SocialButtonWrapperViewController extends ViewController {
    private configRepository: ConfigRepository;
    private userRepository: UserRepository;
    @observable public isFormLoading: boolean = false;

    constructor({ configRepository, userRepository }: ISocialButtonWrapperViewController) {
        super();
        this.configRepository = configRepository;
        this.userRepository = userRepository;
    }

    @computed
    public get data() {
        const provider = getSocialProviderFromStorage();
        const { signInEventSource } = this.userRepository;
        const { socialProviders, formerSelectedProvider } = this.configRepository;

        return {
            isFormLoading: this.isFormLoading,
            provider,
            signInEventSource,
            buttonStyle: socialProviders?.buttonStyle,
            providers: socialProviders?.providers?.filter(
                (item) => item.providerName !== formerSelectedProvider
            )
        };
    }

    @action
    public onLoginClicked = (provider: SignInType) => {
        this.isFormLoading = true;
        new SocialSignInClickedUseCase(provider).execute();
    };
}
